function UserPaymentIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2 10.75H2.19995C1.78995 10.75 1.44995 10.41 1.44995 10C1.44995 9.59 1.78995 9.25 2.19995 9.25H22.2C22.61 9.25 22.95 9.59 22.95 10C22.95 10.41 22.61 10.75 22.2 10.75Z"
        fill="white"
      />
      <path
        d="M11.7502 21.2517H6.6402C2.6602 21.2517 1.44019 20.0517 1.44019 16.1117V7.89172C1.44019 4.74172 2.11018 2.99172 5.68018 2.78172C5.98018 2.77172 6.3002 2.76172 6.6402 2.76172H17.7502C21.7302 2.76172 22.9502 3.96172 22.9502 7.90172V12.3117C22.9502 12.7217 22.6102 13.0617 22.2002 13.0617C21.7902 13.0617 21.4502 12.7217 21.4502 12.3117V7.90172C21.4502 4.81172 20.9002 4.26172 17.7502 4.26172H6.6402C6.3202 4.26172 6.03018 4.27172 5.75018 4.28172C3.58018 4.41172 2.94019 4.90172 2.94019 7.90172V16.1217C2.94019 19.2117 3.4902 19.7617 6.6402 19.7617H11.7502C12.1602 19.7617 12.5002 20.1017 12.5002 20.5117C12.5002 20.9217 12.1702 21.2517 11.7502 21.2517Z"
        fill="white"
      />
      <path
        d="M10.2 16.75H6.19995C5.78995 16.75 5.44995 16.41 5.44995 16C5.44995 15.59 5.78995 15.25 6.19995 15.25H10.2C10.61 15.25 10.95 15.59 10.95 16C10.95 16.41 10.61 16.75 10.2 16.75Z"
        fill="white"
      />
      <path
        d="M18.2 22.75C16.54 22.75 14.98 21.87 14.14 20.44C13.69 19.72 13.45 18.87 13.45 18C13.45 15.38 15.58 13.25 18.2 13.25C20.82 13.25 22.95 15.38 22.95 18C22.95 18.87 22.7099 19.72 22.2599 20.45C21.4199 21.87 19.86 22.75 18.2 22.75ZM18.2 14.75C16.41 14.75 14.95 16.21 14.95 18C14.95 18.59 15.1099 19.17 15.4199 19.67C15.9999 20.65 17.07 21.25 18.2 21.25C19.33 21.25 20.4 20.65 20.98 19.68C21.29 19.17 21.45 18.6 21.45 18C21.45 16.21 19.99 14.75 18.2 14.75Z"
        fill="white"
      />
      <path
        d="M17.6299 19.7415C17.4399 19.7415 17.2499 19.6715 17.0999 19.5215L16.1098 18.5315C15.8198 18.2415 15.8198 17.7615 16.1098 17.4715C16.3998 17.1815 16.8798 17.1815 17.1698 17.4715L17.6499 17.9515L19.2498 16.4715C19.5498 16.1915 20.0298 16.2115 20.3098 16.5115C20.5898 16.8115 20.5699 17.2915 20.2699 17.5715L18.1399 19.5415C17.9899 19.6715 17.8099 19.7415 17.6299 19.7415Z"
        fill="white"
      />
    </svg>
  );
}

export default UserPaymentIcon;
